import {
  LOAD_ALL_CENTER_PRODUCTS,
  LOAD_SINGLE_CENTER_PRODUCT,
} from "./CenterProductsList.saga";

export const loadAllCenterProducts = (payload) => ({
  type: LOAD_ALL_CENTER_PRODUCTS.LOADING,
  payload,
});

export const loadSingleCenterProduct = (payload) => ({
  type: LOAD_SINGLE_CENTER_PRODUCT.LOADING,
  payload,
});
